import { SandpackFile } from "@codesandbox/sandpack-react";

export const getFileContents = (file: SandpackFile | string) => {
  if (typeof file === "string") {
    return file;
  }

  return file.code;
};
